/**
 * Product Upsell Bundle Selection Handler
 * Updates sticky button UI when user selects different bundle options
 */

function createProductUpsell(container) {
  const productId = container.dataset.productId;
  const isMulti = container.dataset.multi === 'true';
  let selectedOption = null;
  let originalProductData = null;

  const getStickyElements = () => {
    const stickyForm = document.querySelector('.product-sticky-form');
    if (!stickyForm) return null;

    const stickyMedia = stickyForm.querySelector('[data-sticky-product-media]');
    const priceContainer = stickyForm.querySelector('.price');

    return {
      form: stickyForm,
      image: stickyMedia?.querySelector('img'),
      title: stickyForm.querySelector('.text-base.font-medium.leading-tight'),
      options: stickyForm.querySelector('[data-sticky-product-options]'),
      priceRegular: priceContainer?.querySelector('.price__regular'),
      priceSale: priceContainer?.querySelector('.price__sale')
    };
  };

  function captureOriginalData() {
    const elements = getStickyElements();
    if (!elements) return;

    originalProductData = {
      image: elements.image?.src,
      imageSrcset: elements.image?.srcset,
      title: elements.title?.textContent,
      options: elements.options?.textContent,
      priceRegular: elements.priceRegular?.innerHTML,
      priceSale: elements.priceSale?.innerHTML
    };

    console.log('📦 Original product data captured');
  }

  function updateStickyButton() {
    const elements = getStickyElements();
    if (!elements || !selectedOption) return;

    if (selectedOption.type === 'single') {
      if (!originalProductData) return;

      if (elements.image && originalProductData.image) {
        elements.image.src = originalProductData.image;
        elements.image.srcset = originalProductData.imageSrcset || '';
      }
      if (elements.title) elements.title.textContent = originalProductData.title;
      if (elements.options) elements.options.textContent = originalProductData.options;
      if (elements.priceRegular) elements.priceRegular.innerHTML = originalProductData.priceRegular;

      if (elements.priceSale) {
        if (originalProductData.priceSale) {
          elements.priceSale.innerHTML = originalProductData.priceSale;
          elements.priceSale.style.display = '';
        } else {
          elements.priceSale.style.display = 'none';
        }
      }

      console.log('🔄 Sticky button reverted to original product');
      return;
    }

    if (elements.image && selectedOption.image) {
      elements.image.src = selectedOption.image;
      const imageUrl = selectedOption.image.split('?')[0];
      elements.image.srcset = `${imageUrl}?width=80 80w, ${imageUrl}?width=160 160w`;
    }

    if (elements.title) {
      elements.title.textContent = selectedOption.title;
    }

    if (elements.options) {
      const countText = selectedOption.productCount > 1
        ? `Kit com ${selectedOption.productCount} unidades`
        : 'Kit bundle';
      elements.options.textContent = countText;
    }

    if (elements.priceRegular) {
      elements.priceRegular.textContent = selectedOption.price;
    }

    if (elements.priceSale) {
      if (selectedOption.comparePrice) {
        elements.priceSale.textContent = selectedOption.comparePrice;
        elements.priceSale.style.display = '';
      } else {
        elements.priceSale.style.display = 'none';
      }
    }

    console.log('🎯 Sticky button updated:', {
      title: selectedOption.title,
      count: selectedOption.productCount
    });
  }

  function updateSelection(radio) {
    container.querySelectorAll('.product-upsell__card').forEach(card => {
      card.classList.remove('product-upsell__card--selected');
    });

    const selectedCard = radio.closest('.product-upsell__card');
    selectedCard?.classList.add('product-upsell__card--selected');

    selectedOption = {
      type: radio.value,
      variantId: radio.dataset.variantId,
      productId: radio.dataset.productId || productId,
      productCount: parseInt(radio.dataset.productCount || '1'),
      title: selectedCard.querySelector('.product-upsell__title')?.textContent.trim() || '',
      image: selectedCard.querySelector('.product-upsell__thumbnail')?.src || '',
      price: selectedCard.querySelector('.product-upsell__final-price')?.textContent.trim() || '',
      comparePrice: selectedCard.querySelector('.product-upsell__compare-price')?.textContent.trim() || ''
    };

    console.log('✅ Upsell selection updated:', selectedOption.type);

    updateStickyButton();
  }

  function refreshMultiSelectionStyles() {
    container.querySelectorAll('.product-upsell__radio').forEach(input => {
      const card = input.closest('.product-upsell__card');
      if (!card) return;
      card.classList.toggle('product-upsell__card--selected', input.checked);
    });
  }

  function selectOnly(input) {
    container.querySelectorAll('.product-upsell__radio').forEach(other => {
      if (other !== input) other.checked = false;
    });
    input.checked = true;
    refreshMultiSelectionStyles();
  }

  function getCheckedItems() {
    return Array.from(container.querySelectorAll('.product-upsell__radio:checked'))
      .map(input => ({
        variantId: input.dataset.variantId,
        productCount: parseInt(input.dataset.productCount || '1', 10)
      }))
      .filter(item => item.variantId);
  }

  async function addItemsToCart(quantity = 1) {
    const items = getCheckedItems();
    if (items.length === 0) {
      alert('Selecione ao menos um item para continuar.');
      return false;
    }

    try {
      const payload = {
        items: items.map(item => ({
          id: parseInt(item.variantId, 10),
          quantity: quantity
        }))
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        console.error('Cart add failed:', errorBody);
        alert(errorBody.description || 'Não foi possível adicionar ao carrinho.');
        return false;
      }

      window.location.href = '/checkout';
      return true;
    } catch (err) {
      console.error('Cart add error:', err);
      alert('Erro ao adicionar ao carrinho. Tente novamente.');
      return false;
    }
  }

  container._upsellApi = { addItemsToCart, getCheckedItems };

  function setupEventListeners() {
    container.querySelectorAll('.product-upsell__radio').forEach(input => {
      input.addEventListener('change', (e) => {
        if (isMulti) {
          if (e.target.checked) {
            selectOnly(e.target);
          } else {
            refreshMultiSelectionStyles();
          }
        } else {
          updateSelection(e.target);
        }
      });
    });

    container.querySelectorAll('.product-upsell__card').forEach(card => {
      card.addEventListener('click', (e) => {
        if (e.target.classList.contains('product-upsell__radio')) return;
        if (e.target.closest('.product-upsell__toggle')) return;

        const input = card.querySelector('.product-upsell__radio');
        if (!input) return;

        if (isMulti) {
          e.preventDefault();
          if (input.checked) {
            input.checked = false;
            refreshMultiSelectionStyles();
          } else {
            selectOnly(input);
          }
        } else if (!input.checked) {
          input.checked = true;
          updateSelection(input);
        }
      });
    });
  }

  function init() {
    if (!isMulti) {
      captureOriginalData();
    }
    setupEventListeners();

    if (isMulti) {
      refreshMultiSelectionStyles();
    } else {
      const firstRadio = container.querySelector('.product-upsell__radio:checked');
      if (firstRadio) updateSelection(firstRadio);
    }

    console.log('✨ Product Upsell initialized', isMulti ? '(multi)' : '(single)');
  }

  init();
}

function initAllUpsells() {
  document.querySelectorAll('.product-upsell').forEach(container => {
    if (container.dataset.initialized === 'true') return;
    createProductUpsell(container);
    container.dataset.initialized = 'true';
  });
}

initAllUpsells();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllUpsells);
}

document.addEventListener('shopify:section:load', initAllUpsells);

document.addEventListener(
  'click',
  function (e) {
    const buyBtn = e.target.closest('.javazap-hero__buy-btn, [data-upsell-buy-button]');
    if (!buyBtn) return;

    const hero = buyBtn.closest('.javazap-hero, [data-section-id]') || document;
    const upsell = hero.querySelector('.product-upsell--multi');
    if (!upsell || !upsell._upsellApi) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    const qtyInput = document.querySelector(
      '.product-sticky-form quantity-input input[type="number"], .javazap-hero quantity-input input[type="number"]'
    );
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    upsell._upsellApi.addItemsToCart(quantity);
  },
  true
);
